import { render, staticRenderFns } from "./Buiten.vue?vue&type=template&id=bf256118&"
import script from "./Buiten.vue?vue&type=script&lang=js&"
export * from "./Buiten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports